import { mapMutationsFromTypes } from 'schepotin-vuex-helpers';
import * as types from './mutation-types';

export default {
    /**
     * Generates {@link https://vuex.vuejs.org/en/mutations.html | mutations} from
     * {@link https://vuex.vuejs.org/en/mutations.html#using-constants-for-mutation-types | mutation types}
     *
     * Documentation
     * {@link https://www.npmjs.com/package/schepotin-vuex-helpers#mapmutationsfromtypes | mapMutationsFromTypes}
     */
    ...mapMutationsFromTypes({
        types,
        excludes: [
            types.SHOW_UNLOCK_LEVEL_POPUP,
            types.HIDE_UNLOCK_LEVEL_POPUP,
        ],
    }),
    [types.SHOW_UNLOCK_LEVEL_POPUP](state, payload) {
        state.unlockLevel.lesson_id = payload;
        state.unlockLevel.visible = true;
    },
    [types.HIDE_UNLOCK_LEVEL_POPUP](state) {
        state.unlockLevel.lesson_id = null;
        state.unlockLevel.visible = false;
    },
};



// WEBPACK FOOTER //
// ./src/store/modules/popup/mutations.js